import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

let UiCBoxRadiusComponent = class UiCBoxRadiusComponent {
    constructor() {
        this.continue = new EventEmitter();
    }
    continueBtn() {
        this.continue.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "image", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "class", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "textTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "textDescription", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "titlePosition", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCBoxRadiusComponent.prototype, "icon", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCBoxRadiusComponent.prototype, "continue", void 0);
UiCBoxRadiusComponent = __decorate([
    Component({
        selector: 'ui-c-box-radius',
        template: "<div class=\"d-flex align-items-center justify-content-center box-radius border ion-padding space-right\" (click)=\"continueBtn()\">\n  <ng-container *ngIf=\"!!icon\">\n    <ion-item lines=\"none\" class=\"ion-item\">\n      <ion-icon class=\"ion-icon\" [name]=\"icon\"></ion-icon>\n    </ion-item>\n  </ng-container>\n  <div class=\"box-radius-inner\">\n    <ng-container *ngIf=\"titlePosition === 'top'\">\n      <ion-row class=\"d-flex ion-justify-content-center\">\n        <ion-col size=\"8\" class=\"d-flex ion-justify-content-center ion-align-items-center\">\n          <ion-text class=\"ion-text ion-text-center\">\n            <p class=\"d-flex flex-column ion-justify-content-center ion-text font-family-bold font-size-16 ion-no-margin\">{{ textTitle }} <span *ngIf=\"textDescription\"> - {{ textDescription }}</span></p>\n          </ion-text>\n        </ion-col>\n      </ion-row>\n    </ng-container>\n\n    <ion-row class=\"ion-justify-content-center\">\n      <ion-col size=\"8\" class=\"d-flex ion-justify-content-center ion-align-items-center ion-col-img ion-text-center\">\n        <svg-icon [stretch]=\"false\" class=\"ion-img\" [src]=\"image\" *ngIf=\"!!class\"> </svg-icon>\n        <div *ngIf=\"class\" [class]=\"class\"></div>\n      </ion-col>\n    </ion-row>\n\n    <ng-container *ngIf=\"titlePosition === 'bottom'\">\n      <ion-row class=\"d-flex ion-justify-content-center\">\n        <ion-col size=\"8\" class=\"d-flex ion-justify-content-center ion-align-items-center\">\n          <ion-text class=\"ion-text ion-text-center\">\n            <p class=\"d-flex flex-column ion-justify-content-center ion-text font-family-bold font-size-14 ion-no-margin color-secondary\">{{ textTitle }} <span *ngIf=\"textDescription\"> - {{ textDescription }}</span> </p>\n          </ion-text>\n        </ion-col>\n      </ion-row>\n    </ng-container>\n  </div>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCBoxRadiusComponent);

let UiCBoxRadiusModule = class UiCBoxRadiusModule {
};
UiCBoxRadiusModule = __decorate([
    NgModule({
        declarations: [UiCBoxRadiusComponent],
        imports: [CommonModule, IonicModule, AngularSvgIconModule.forRoot()],
        exports: [UiCBoxRadiusComponent],
    })
], UiCBoxRadiusModule);

export { UiCBoxRadiusComponent, UiCBoxRadiusModule };
//# sourceMappingURL=wlp-ui-c-box-radius.js.map
